/**
 * TaskWorkReportsSection — the task binding of
 * ``EntityWorkReportsSection`` (D1).
 *
 * D2a generalised the section so the tenant tab could reuse it. This
 * wrapper pins the task wording and keeps the D1 call site unchanged;
 * the label helpers are re-exported so the D1 tests still import them
 * from here.
 */
import React from "react";

import EntityWorkReportsSection from "./entityWorkReports/EntityWorkReportsSection";

export {
  assigneeLabel,
  linkedLabel,
  reportCountLabel,
  reportHeadline,
  spokenDuration,
  timeRangeLabel,
} from "./entityWorkReports/EntityWorkReportsSection";

export default function TaskWorkReportsSection(props) {
  return (
    <EntityWorkReportsSection
      {...props}
      scope="task"
      headingId="task-reports-heading"
      emptyText="Für diese Aufgabe wurden noch keine Rapporte erfasst."
    />
  );
}
